export default __webpack_public_path__ + "static/media/upto70.628fca68.png";